import React from 'react';

// Input cu datalist - permite si scriere libera si selectie din lista
export default function EditableSelect({ value, onChange, options, placeholder, disabled }) {
  const id = 'ds_' + Math.random().toString(36).substr(2, 9);
  return (
    <>
      <input
        list={id}
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder || ''}
        disabled={disabled}
        style={{ width: '100%', padding: '5px 8px', border: '1px solid #ccc', borderRadius: 4, fontSize: 12,
          background: disabled ? '#eee' : 'white', cursor: disabled ? 'not-allowed' : 'text' }}
      />
      <datalist id={id}>
        {options && options.map(o => <option key={o} value={o} />)}
      </datalist>
    </>
  );
}
